<div nz-row class="semi-intro-image"></div>
<div class="semi-message">
  <div class="content">
    <div style="font-weight: bold; padding-bottom: 5px; font-size: 28px;">
      반도체 사업부 소개<br />
    </div>
    <div style="font-weight: normal; font-size: 18px;">
      <p>
        당 사업부는 SK Hynix 공식 대리점으로서 전문 인력 기반의 기술지원 및 영업 능력을<br/>
        활용하여 DRAM Memory, Flash Memory, MCP, SSD, CIS 등 SK Hynix에서 생산되는<br/>
        전 제품 군을 취급하고 있습니다.
      </p>
    </div>
  </div>
</div>

<div class="semi-product">
  <div style="height: 100px;"></div>
  <div class="content"><p style="font-family: 'Noto Sans',sans-serif; font-size: 18px; font-weight: bold;">제품 소개</p></div>
  <div style="height: 100px;"></div>
  <div class="content">
    <div style="font-family: Roboto,sans-serif; font-weight: bold; font-size: 38px; padding-bottom: 5px;">DRAM</div>
    <div style="font-family: 'Noto Sans',sans-serif; font-size: 16px;">
      <p>
        PC DRAM, Server DRAM, Mobile DRAM, Graphic DRAM 뿐 아니라<br/>
        자율 주행 차량 등에 적용 가능한 Automotive 제품 등 고객의 다양한 기준을 충족하는 제품을 제공합니다.
      </p>
    </div>
  </div>
  <div class="dram-image"></div>
  <div class="dram-info">
    <div class="title" style="background: #F7F7F7; height: 68px;">
      <div style="margin-left: 30px; margin-top: 20px; text-align: left">
        01 Computing DRAM
      </div>
    </div>
    <div class="desc" style="height: 146px; background: white; float: left">
      <div style="margin-left: 30px; margin-top: 40px; text-align: left">
        가정용 PC에서부터 대형 서버 시스템에 이르기까지 전 방위적인 시스템의<br/>
        주 메모리로 사용되는 제품입니다.
      </div>
    </div>
  </div>

  <div style="height: 100px;"></div>

  <div class="content">
    <div style="font-family: Roboto; font-weight: bold; font-size: 38px; padding-bottom: 5px;">NAND Flash</div>
    <div style="font-family: 'Noto Sans',sans-serif; font-size: 16px;">
      <p>
        MP3, PMP, 디지털 카메라, 네비게이션 등 단순한 저장 장치로 사용되는 NAND Flash의<br/>
        폭 넓은 Density의 제품 지원을 통해 고객의 다양한 요구를 충족시키는 최고의 NAND Solution을 제공합니다.
      </p>
    </div>
  </div>
  <div class="nand-image"></div>
  <div class="dram-info">
    <div class="title" style="background: #F7F7F7; height: 68px;">
      <div style="margin-left: 30px; margin-top: 20px; text-align: left">
        01 Raw NAND
      </div>
    </div>
    <div class="desc" style="height: 146px; background: white;">
      <div style="margin-left: 30px; margin-top: 40px; text-align: left" nz-col>
        전력이 차단 된 후에도 DATA가 소실되지 않는 특성을 이용하여 USB, SD Card,<br/>
        T-Flash, SSD 등 다양한 Storage 제품 군에 적용되는 대표 제품입니다.
      </div>
    </div>
  </div>

  <div style="height: 100px;"></div>

  <div class="content">
    <div style="font-family: Roboto; font-weight: bold; font-size: 38px; padding-bottom: 5px;">CMOS Image Sensor</div>
    <div style="font-family: 'Noto Sans',sans-serif; font-size: 16px;">
      <p>
        영상신호를 저장하고 전송하여 촬영한 사진을 디스플레이 장치로 볼 수 있도록 만들어 주는 반도체로서,<br/>
        스마트폰, 자율주행, 보안솔루션, 인공지능, 가상·증강현실 등 다양한 산업분야에서 수요가 확대되는 제품입니다.
      </p>
    </div>
  </div>
  <div class="cmos-image"></div>
</div>

<div style="height: 50px;"></div>
<div class="customer-center-footer" nz-row>
  <p nz-col>
    <label style="font-family: Roboto; font-size: 40px; font-weight: bold">Customer Center</label><br/>
    <label style="font-family: 'Noto Sans',sans-serif; font-size:20px;">문의 주시면 정성을 다해 상담 드리겠습니다</label>
  </p>
  <div class="arrow" nz-col (click)="onClickGotoRequest()"></div>
</div>
<div class="main-footer" nz-row>
  <p>COPYRIGHT BY (C) 2009 HYUNDAI GREEN TECH ALL RIGHTS RESERVED.<br/>
    [SEOUL]  T 02-2115-8815  F 02-2115-8818  [CHEON-AN] T 041-582-2214, 2215  F 041-588-2215</p>
</div>
